import { useState, useEffect } from 'react';
import { patientsApi, type PatientAllergy } from '@/api';

export interface UsePatientAllergiesResult {
  data: PatientAllergy[];
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export function usePatientAllergies(patientId?: string): UsePatientAllergiesResult {
  const [data, setData] = useState<PatientAllergy[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [refetchIndex, setRefetchIndex] = useState(0);

  useEffect(() => {
    if (!patientId) {
      setData([]);
      setError(null);
      return;
    }

    let active = true;
    setIsLoading(true);
    setError(null);

    patientsApi
      .getPatientAllergies(patientId)
      .then((allergies) => {
        if (!active) return;
        setData(allergies ?? []);
      })
      .catch((err) => {
        if (!active) return;
        setError(err instanceof Error ? err.message : 'Erro ao carregar alergias do paciente');
      })
      .finally(() => {
        if (active) {
          setIsLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [patientId, refetchIndex]);

  const refetch = () => {
    setRefetchIndex((index) => index + 1);
  };

  return { data, isLoading, error, refetch };
}
